module.exports = "https://cdn.hellotech.com/client-assets/hubs_and_speakers_desktop_9a3125035a7cbd10a5340f92c18a7a29.png";